export default "__VITE_PUBLIC_ASSET__ab962366__"